/**
*功能名称：审批通过
*创 建 人：弋强
*日    期：2022/08/18 14:18:56
*/
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";
@Component({
    components: {
        comForm,
    }
})
export default class ApprovePass extends BaseVue {

    //#region 接口定义区

    //#endregion 接口定义区

    //#region 变量定义区

    passModel: any = {
        msg: this.getProjectDataId() == 23 ? '已阅' : '同意',
        nextUserIds: '',
        date: this.getCurrentDate(),
    }
    mainFormItemData: any = [
        {
            label: "审批日期",
            type: "datePicker",
            prop: "date",
            model: "date",
            transfer: true,
            col: 24
        },
        {
            label: '审批意见',
            type: "input",
            inputType: "textarea",
            prop: 'msg',
            model: 'msg',
            col: 24,
        },
    ]

    //#endregion 变量定义区

    //#region 事件定义区

    mounted() {
        //页面渲染完出发事件
    }

    //#endregion 事件定义区

    //#region 方法定义区

    getData() {
        return this.passModel;
    }

    //#endregion 方法定义区
}